const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] as const;
export type Unit = (typeof units)[number];

// units配列も公開
export const BYTE_UNITS = units;

export function convertSize(
  value: number,
  fromUnit: Unit,
  toUnit: Unit,
): number {
  const fromIndex = units.indexOf(fromUnit);
  const toIndex = units.indexOf(toUnit);

  if (fromIndex === -1 || toIndex === -1) {
    throw new Error('Invalid unit');
  }

  // 差分を求めて1024のべき乗で変換
  const factor = Math.pow(1024, fromIndex - toIndex);
  return value * factor;
}

export function formatFloatNumber(value: number, fractionDigits?: number) {
  return parseFloat(value.toFixed(fractionDigits ?? 2).toString());
}

/**
 * ファイルサイズを適切な単位で表示する
 * @param bytes バイト数
 * @returns フォーマットされたファイルサイズ文字列
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';

  const displayUnits: Unit[] = ['B', 'KB', 'MB', 'GB', 'TB'];
  let size = bytes;
  let unitIndex = 0;

  // 1024以上の場合は次の単位に進む
  while (size >= 1024 && unitIndex < displayUnits.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  return `${formatFloatNumber(size)} ${displayUnits[unitIndex]}`;
}
